import { FC } from 'react'
import cx from 'classnames'

const ListingBadge = ({
  text,
  icon: Icon,
  className,
}: {
  text: string
  icon?: FC<{ className?: string }>
  className?: string
}) => {
  return (
    <div
      className={cx(
        className,
        'flex items-center rounded-lg bg-gold-1 px-8 py-4'
      )}
    >
      {Icon ? (
        <Icon
          aria-hidden="true"
          className="mr-8 flex-shrink-0 stroke-grey-8 rect-14"
        />
      ) : null}
      <span className="font-sans text-12 font-bold">{text}</span>
    </div>
  )
}

export default ListingBadge
